<div>
  <mm-spinner></mm-spinner>
  <router-outlet>
    <!-- Html per redireccionar les URL's del projecte -->
  </router-outlet>
</div>
